module.exports = __webpack_public_path__ + "static/media/my-maps.21aec1e8.svg";